import React from 'react';

import Select from './Select';

/**
 * Code from : https://github.com/ant-design/ant-design/issues/12440
 */
/**
 * @typedef {{
 *  isFetching?: boolean,
 *  apiError?: string,
 *  links?: { next?: boolean },
 *  loadMore?: (searchParameters?: Object) => void,
 *  searchParameters?: Object,
 *  handleWithValue?: boolean
 * } & import("antd").SelectProps} FBPaginatedSelectProps
 */

/** @type {React.FC<FBPaginatedSelectProps>} */
const FBPaginatedSelect = props => {
  const {
    isFetching,
    apiError,
    links,
    loadMore,
    searchParameters,
    children,
    mode = 'default',
    value,
    handleWithValue = false,
    ...rest
  } = props;

  const [propsToAdd, setPropsToAdd] = React.useState();

  React.useEffect(() => {
    // keep tmp empty to avoid to have a value props undefined on select.
    const tmp = {};
    if (value || handleWithValue) {
      tmp.value = mode === 'multiple' && value === '' ? [] : value;
    }
    setPropsToAdd(tmp);
  }, [value]);

  const scrollListener = React.useCallback(
    ({ target }) => {
      const { scrollTop, offsetHeight, scrollHeight } = target;
      const canFetch = links?.next && !isFetching && !apiError;

      if (Math.ceil(scrollTop + offsetHeight) >= scrollHeight && canFetch) {
        loadMore(searchParameters);
      }
    },
    [searchParameters, loadMore, links, isFetching, apiError]
  );

  return (
    <Select
      mode={mode}
      loading={isFetching}
      onPopupScroll={scrollListener}
      {...propsToAdd}
      {...rest}
    >
      {children}
    </Select>
  );
};

export default FBPaginatedSelect;
